import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * React Router doesn't reset scroll position between routes on its own —
 * without this, navigating from a scrolled-down list (the guides index, a
 * related-guides link near the bottom of an article) to a new page lands
 * you wherever the previous page happened to be scrolled to, not the top
 * of the new one. Skips the reset when the URL carries a hash, since that
 * means something (e.g. Landing's `#how-it-works` link) wants to scroll to
 * a specific section instead.
 */
export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
